import { z } from 'zod';
import { VehicleSchema } from '../vehicle';

export const orderVehicleSchema = VehicleSchema.model.pick({
  _id: true,
  title: true,
  registration: true,
  classification: true,
  org: true,
});

export type orderVehicleSchema = z.infer<typeof orderVehicleSchema>;
